// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-control.custom-control-inline.custom-switch {\n  width: 48%;\n}[dir] .custom-control.custom-control-inline.custom-switch {\n  margin-bottom: 0.5rem;\n}\n[dir] .table.table-sm td {\n  padding: 0.5rem;\n}\n.input-group {\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n}\ninput[name=availableQuote] {\n  min-width: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
